export default {
  noFund: '無內部轉賬記錄',
  fund_transefer: '內部轉賬',
  from_account: '扣款賬戶',
  to_account: '收款賬戶',
  to_currency: '扣款貨幣',
  balance: '可轉賬金額',
  error_transfer_check: '還有未處理的轉賬訂單',
  success: '您的轉賬申請已成功提交,如有問題請與我們聯繫',
  sameOutAndIn: '您的轉出和轉入賬號重複,請重新選擇,如有問題請與我們聯繫',
  transefer_amount: '轉賬金額',
  validate: {
    max: '轉賬金額不得大於對應幣種可轉賬金額',
    maxMt5: '轉賬金額不得大於可用預付款',
    min: '轉賬金額不得小於0.01',
    pinyinName: '請輸入姓名拼音',
    correctAmount: '請輸入正確的金額'
  },
  info_dialog: {
    application_number: '您的申請編號是',
    reminder: '我們會盡快處理您的申請，您可以撥打+852 2655 0338 / 400 120 0068（中國內地免費熱線）與我們聯繫！ ',
    submitSuccess: '提交成功'
  },
  balanceLow: '沒有餘額',
  acceptableAmount: '建議最大可轉賬金額',
  largestAmount: '為降低轉賬後賬戶資金緊張而短期內出現強制平倉的風險，此為建議最大轉賬金額。同時，轉賬之金額不可大於賬戶「可用保證金」金額。',
  transferInterTip: `
  1. 內部轉賬支持7×24小時全天候辦理。對於未能即時順利辦理的申請，將由專人於工作日辦公時間內跟進處理。 <br />
  2. 結單顯示規則 <br />
  （以下均為香港時間） <br />
  <span style="color:#333;font-weight:500;">(I) 證券/基金賬戶：</span>客戶於每日16:59或之前辦理完成的內部轉賬將反映在當日的結單；其後完成的內部轉賬將顯示在下一交易日的結單。 <br />
  <span style="color:#333;font-weight:500;">(II) 期貨賬戶：</span>客戶於星期一至五（元旦除外）06:00至翌日05:59期間辦理完成的內部轉賬將反映在當日的結單；於星期六05:59後辦理完成的申請將顯示在下一交易日的結單。 <br />
  備註：若內部轉賬於每年元旦當日辦理完成，相關記錄將顯示在下一交易日的結單。 <br />
  <span style="color:#333;font-weight:500;">(III) 槓桿式外匯賬戶：</span> <br />
  <span style="color:#333;font-weight:500;">美東夏令時間：</span> <br />
  星期一至五05:05至翌日04:55期間辦理完成的內部轉賬將反映在當日的結單；於星期六04:55後辦理完成的内部轉賬將顯示在下一交易日的結單。 <br />
  <span style="color:#333;font-weight:500;">美東冬令時間：</span> <br />
  星期一至星期五當日06:05至翌日05:55期間辦理完成的內部轉賬將反映在當日的結單；於星期六05:55後辦理完成的内部轉賬將顯示在下一交易日的結單。 `
}
